export abstract class CapacityChartPluginHelper {
  public static getOrCreateLegendList(chart: any, id: string) {
    let legendContainer = document.getElementById(id);
    if (!legendContainer) {
      legendContainer = document.createElement("div");
      legendContainer.id = id;
      chart.canvas?.parentNode.insertBefore(
        legendContainer,
        chart.canvas.nextSibling
      );
    }
    let listContainer = legendContainer?.querySelector("ul");

    if (!listContainer) {
      listContainer = document.createElement("ul");
      listContainer.style.display = "flex";
      listContainer.style.justifyContent = "right";
      listContainer.style.margin = "0";
      listContainer.style.padding = "0";
      listContainer.style.listStyleType = "none";
      listContainer.classList.add("amd-container-hcenter");
      listContainer.classList.add("ma-0");
      listContainer.classList.add("pa-0");
      listContainer.classList.add("li-type-none");
      legendContainer?.appendChild(listContainer);
    }

    return listContainer;
  }

  public static getBorderStyle(item: any) {
    return item.lineDash?.length > 0 ? "dashed" : "solid";
  }
  public static getTextDecoration(item: any) {
    return item.hidden ? "line-through" : "";
  }
}
